<template>
  <div>
    <div v-show="language === 'CHINESE'">
      <pre>一、开通交易账户</pre>
      <pre>
        <p>尊敬的用户，在您自主选择开通金果子交易账户前，请您务必悉知数字资产交易的各项风险，结合自身经济状况及风险承受能力，审慎决策是否选择使用，避免给您的数字资产带来不必要的损失。</p>
      </pre>
      <pre>
        <p>请您务必认真阅读并理解以下重要提示：</p>
      </pre>
      <pre>
        <p>1. 您了解本软件仅作为您获取数字资产信息、寻找交易方、就数字资产的交易进行协商及开展交易的场所，本平台不参与您的任何交易，故您应自行谨慎判断确定相关数字资产及/或信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。</p>
        <p>2. 本平台的任何意见、消息、探讨、分析、价格、建议和其他资讯均是一般的市场评论，并不构成投资建议。我们不承担任何因依赖该资讯直接或间接而产生的损失，包括但不限于任何利润损失。</p>
        <p>3. 本软件保留随时自行决定、修改或变更本内容的权利。</p>
        <p>4. 使用互联网形式的交易系统亦存有风险，包括但不限于软件，硬件和互联网连接失败等。由于我们不能控制互联网的可靠性和可用性，我们不会对失真，延误和连接失败而承担任何责任。</p>
        <p>5. 禁止使用本软件从事洗钱、走私、商业贿赂等一切非法交易活动或违法行为，若发现任何涉嫌非法交易或违法行为，本站将采取各种可使用之手段，包括但不限于冻结账户，通知相关权力机关等，我们不承担由此产生的所有责任并保留向相关人士追究责任的权利。</p>
        <p>6. 禁止使用本软件进行恶意操纵市场、不正当交易等一切不道德交易活动，若发现此类事件，本软件将对所有恶意操纵价格、恶意影响交易系统等不道德的行为采取警告、限制交易、关停账户等预防性的保护措施，我们不承担由此产生的所有责任并保留向相关人士追究责任的权利。</p>
        <p>您了解和理解此交易有可能导致部分损失或全部损失，所以您应该以能承受的损失程度来决定交易的金额。您了解和理解数字资产会产生衍生风险，所以如有任何疑问，建议先寻求专业顾问的协助。此外，除了上述提及过的风险以外，还会有未能预测的风险存在。您应慎重考虑并用清晰的判断能力去评估自己的财政状况及上述各项风险而作出任何买卖数字资产的决定，并承担由此产生的全部损失，我们对此不承担任何责任。</p>
      </pre>
      <pre>二、开通量化账户</pre>
      <pre>
        <p>尊敬的用户，在您自主选择进行金果子量化交易前，请您务必悉知量化交易的各项风险，结合自身经济状况及风险承受能力，审慎决策是否选择使用，避免给您的数字资产带来不必要的损失。</p>
      </pre>
      <pre>
        <p>量化交易风险包括但不限于以下几点：</p>
      </pre>
      <pre>
        <p>1. 停牌风险。您选择进行量化交易的币种可能会出现停牌等停止交易情况，可能会影响量化策略参数，造成风险，请您务必重新评估风险后审慎选择是否终止原量化策略。</p>
        <p>2. 单边行情。量化交易较适合震荡行情赚取差价，若您当前进行量化交易的币种出现了单边上涨或单边下跌的行情时，会影响量化策略的准确性，请您务必重新评估并自主决策是否调整原量化策略，以避免给您带来经济损失。</p>
        <p>3. 收益回测数据仅代表历史数据，并不作为对您使用量化策略的收益承诺与保证。</p>
      </pre>
      <pre>
        <p>同时，请您务必认真阅读并理解以下重要提示：</p>
      </pre>
      <pre>
        <p>1、您使用量化策略进行交易的行为，均为您个人自由选择的行为，我们并不强制您使用，也不向您推荐使用；</p>
        <p>2、受各种因素影响，我们不对量化策略的有效性、准确性、可靠性、质量、稳定、完整和及时性作出任何承诺和保证；</p>
        <p>3、您自行承担使用量化策略进行交易而产生的全部责任，我们不对此承担任何责任。 最终解释权归金果子所有；</p>
        <p>4、 市场最优价格买卖造成的价差（滑点）风险。开启策略和停止策略时，会以市场最优价格进行买卖操作，在操作过程中市场价格波动可能会产生部分价差，导致亏损。</p>
      </pre>
    </div>
    <div v-show="language === 'CHINESETRAD'">
      <pre>一、開通交易帳戶</pre>
      <pre>
        <p>尊敬的用戶，在您自主選擇開通JGZ交易帳戶前，請您務必悉知數字資產交易的各項風險，結合自身經濟狀況及風險承受能力，審慎決策是否選擇使用，避免給您的數字資產帶來不必要的損失。</p>
      </pre>
      <pre>
        <p>請您務必認真閱讀並理解以下重要提示：</p>
      </pre>
      <pre>
        <p>1. 您瞭解本軟體僅作為您獲取數字資產資訊、尋找交易方、就數字資產的交易進行協商及開展交易的場所，本平臺不參與您的任何交易，故您應自行謹慎判斷確定相關數字資產及/或資訊的真實性、合法性和有效性，並自行承擔因此產生的責任與損失。</p>
        <p>2. 本平臺的任何意見、消息、探討、分析、價格、建議和其他資訊均是一般的市場評論，並不構成投資建議。我們不承擔任何因依賴該資訊直接或間接而產生的損失，包括但不限於任何利潤損失。</p>
        <p>3. 本軟體保留隨時自行決定、修改或變更本內容的權利。</p>
        <p>4. 使用互聯網形式的交易系統亦存有風險，包括但不限於軟體，硬體和互聯網連接失敗等。由於我們不能控制互聯網的可靠性和可用性，我們不會對失真，延誤和連接失敗而承擔任何責任。</p>
        <p>5. 禁止使用本軟體從事洗錢、走私、商業賄賂等一切非法交易活動或違法行為，若發現任何涉嫌非法交易或違法行為，本站將採取各種可使用之手段，包括但不限於凍結帳戶，通知相關權力機關等，我們不承擔由此產生的所有責任並保留向相關人士追究責任的權利。</p>
        <p>6. 禁止使用本軟體進行惡意操縱市場、不正當交易等一切不道德交易活動，若發現此類事件，本軟體將對所有惡意操縱價格、惡意影響交易系統等不道德的行為採取警告、限制交易、關停帳戶等預防性的保護措施，我們不承擔由此產生的所有責任並保留向相關人士追究責任的權利。</p>
        <p>您瞭解和理解此交易有可能導致部分損失或全部損失，所以您應該以能承受的損失程度來決定交易的金額。您瞭解和理解數字資產會產生衍生風險，所以如有任何疑問，建議先尋求專業顧問的協助。此外，除了上述提及過的風險以外，還會有未能預測的風險存在。您應慎重考慮並用清晰的判斷能力去評估自己的財政狀況及上述各項風險而作出任何買賣數字資產的決定，並承擔由此產生的全部損失，我們對此不承擔任何責任。</p>
      </pre>
      <pre>二、開通量化帳戶</pre>
      <pre>
        <p>尊敬的用戶，在您自主選擇進行JGZ量化交易前，請您務必悉知量化交易的各項風險，結合自身經濟狀況及風險承受能力，審慎決策是否選擇使用，避免給您的數字資產帶來不必要的損失。</p>
      </pre>
      <pre>
        <p>量化交易風險包括但不限於以下幾點：</p>
      </pre>
      <pre>
        <p>1. 停牌風險。您選擇進行量化交易的幣種可能會出現停牌等停止交易情況，可能會影響量化策略參數，造成風險，請您務必重新評估風險後審慎選擇是否終止原量化策略。</p>
        <p>2. 單邊行情。量化交易較適合震盪行情賺取差價，若您當前進行量化交易的幣種出現了單邊上漲或單邊下跌的行情時，會影響量化策略的準確性，請您務必重新評估並自主決策是否調整原量化策略，以避免給您帶來經濟損失。</p>
        <p>3. 收益回測數據僅代表歷史數據，並不作為對您使用量化策略的收益承諾與保證。</p>
      </pre>
      <pre>
        <p>同時，請您務必認真閱讀並理解以下重要提示：</p>
      </pre>
      <pre>
        <p>1、您使用量化策略進行交易的行為，均為您個人自由選擇的行為，我們並不強制您使用，也不向您推薦使用；</p>
        <p>2、受各種因素影響，我們不對量化策略的有效性、準確性、可靠性、品質、穩定、完整和及時性作出任何承諾和保證；</p>
        <p>3、您自行承擔使用量化策略進行交易而產生的全部責任，我們不對此承擔任何責任。 最終解釋權歸JGZ所有； </p>
        <p>4、 市場最優價格買賣造成的價差（滑點）風險。開啟策略和停止策略時，會以市場最優價格進行買賣操作，在操作過程中市場價格波動可能會產生部分價差，導致虧損。</p>
      </pre>
    </div>
    <div v-show="language === 'ENGLISH'">
      <pre>Create Trading Account</pre>
      <pre>
        <p>Dear users, before you independently choose to carry out quantitative trading with J Golden Zone,please make sure you are aware of the risks of quantitative trading, combine your own economic situation and risk tolerance, and make a prudent decision on whether to choose to use it to avoid unnecessary losses to your crypto assets.</p>
      </pre>
      <pre>
        <p>Please be sure to carefully read and understand the following important tips.</p>
      </pre>
      <pre>
        <p>1 .You understand that this app only serves as a place for you to obtain information on crypto assets, find counterparties, negotiate and conduct transactions on crypto assets, and this platform does not participate in any of your transactions, so you should make your own careful judgment to determine the authenticity, legality and validity of the relevant digital assets and/or information, and bear the responsibility and losses arising therefrom.</p>
        <p>2. Any opinions, news, discussions, analyses, prices, recommendations and other information on this platform are general market commentary and do not constitute investment advice. We do not assume any liability for any loss arising directly or indirectly from reliance on such information, including but not limited to any loss of profits.</p>
        <p>3. The Software reserves the right to determine, modify or change this content at any time at its sole discretion.</p>
        <p>4. The use of Internet-based trading systems is subject to risks, including, but not limited to, software, hardware and Internet connection failures. Since we have no control over the reliability and availability of the Internet, we will not be liable for distortions, delays or connection failures.</p>
        <p>5. Prohibit the use of the software to engage in money laundering, smuggling, commercial bribery and other illegal trading activities or illegal behavior, if any suspected illegal transactions or illegal behavior, the site will take a variety of available means, including but not limited to freezing the account, notify the relevant authorities, etc., we do not assume all the responsibilities arising from this and reserve the right to pursue responsibility from the relevant parties.</p>
        <p>6. The use of this software is prohibited for malicious market manipulation, improper trading and all other unethical trading activities. If such events are found, this software will take preventive protection measures such as warning, restricting trading, shutting down accounts, etc. for all malicious price manipulation, malicious influence on the trading system and other unethical behaviors, we do not assume all responsibilities arising from this and reserve the right to pursue responsibilities from related parties. </p>
        <p>You understand that this transaction may result in partial or total loss and that you should determine the amount of the transaction based on the amount of loss you can afford. You understand that there are derivative risks associated with digital assets, so if you have any questions, you are advised to seek the assistance of a professional advisor first. In addition, in addition to the risks mentioned above, there are unpredictable risks. You should make any decision to buy or sell digital assets with careful consideration and clear judgment in assessing your financial situation and the risks described above, and you assume full responsibility for any resulting losses, for which we shall not be liable.</p>
      </pre>
      <pre>Create Quantitative Account</pre>
      <pre>
        <p>Dear users, before you independently choose to carry out quantitative trading with J Golden Zone,please make sure you are aware of the risks of quantitative trading, combine your own economic situation and risk tolerance, and make a prudent decision on whether to choose to use it to avoid unnecessary losses to your crypto assets.</p>
      </pre>
      <pre>
        <p>Quantitative trading risks include but are not limited to the following.</p>
      </pre>
      <pre>
        <p>1. Suspension risk. The coins you choose to trade quantitatively may have trading suspensions and other stoppages, which may affect the parameters of the quantitative strategy and cause risk. Please make sure you re-evaluate the risk and then carefully choose whether to terminate the original quantitative strategy.</p>
        <p>2. One-sided market. If the currency you are currently trading in has a one-sided up or one-sided down market, it will affect the accuracy of the quantitative strategy. Please make sure to re-evaluate and make your own decision whether to adjust the original quantitative strategy to avoid financial loss.</p>
        <p>3. The return backtest data only represents the historical data, and does not serve as a promise or guarantee for the return of your quantitative strategy.</p>
      </pre>
      <pre>
        <p>At the same time, please make sure you read and understand the following important tips.</p>
      </pre>
      <pre>
        <p>1. your use of quantitative strategies for trading are your personal choice, we do not force you to use them, nor do we recommend them to you.</p>
        <p>2.subject to various factors, we do not quantitative strategy of the effectiveness, accuracy, reliability, quality, stability, integrity and timeliness to make any promises and guarantees.</p>
        <p>3.you bear the full responsibility of using quantitative strategies for trading, we do not assume any responsibility for this. The final right of interpretation belongs to Golden Fruits.</p>
        <p>4. the spread (slippage) risk caused by the best market price buying and selling. When you open and stop the strategy, you will buy and sell at the best price in the market, and the market price fluctuation during the operation may generate part of the spread, resulting in a loss.</p>
      </pre>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            language: 'CHINESE'
        }
    },
    mounted() {
        if(this.$i18n.locale === 'zh') {
            this.language = 'CHINESE'
        } else if (this.$i18n.locale === 'zh-h'){
            this.language = 'CHINESETRAD'
        } else {
            this.language = 'ENGLISH'
        }
    }
}
</script>

<style lang='less' scoped>
div {
    min-height: 100vh;
    background: #ffffff;
    text-align: left;
    padding: 40px;
}
h1 {
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    line-height: 60px;
}
p {
    line-height: 48px;
    // margin-bottom: 20px;
}
pre {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    white-space: pre-wrap;
}
</style>